<template>
  <div class="index-page page-main">
    <div class="logo-box">
      <img src="../../assets/logo.png" class="logo" alt="" />
    </div>

    <div class="card-box">
      <div class="coupon-item">
        <div class="coupon-box">
          <div class="left">
            <div class="price-box">
              <span class="symbol">￥</span>
              <span class="price">{{
                coupon.subPrice ? coupon.subPrice : coupon.price
              }}</span>
            </div>
            <div class="desc">
              满{{ coupon.fullPrice ? coupon.fullPrice : coupon.price }}元可用
            </div>
          </div>
          <div class="right">
            <div class="right-left">
              <div class="coupon-title">{{ coupon.couponName }}</div>
              <div class="desc">领取后{{ coupon.validityPeriod }}天内有效</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-item">
      <input type="number" v-model="phone" placeholder="请输入手机号" />
    </div>

    <div class="button" @click="reviceCoupon">领取优惠券</div>

    <div class="button" @click="toWechatExe">去小程序看看</div>
  </div>
</template>
<script>
import api from "@/api/api";

export default {
  props: {},
  data() {
    return {
      phone: "",
      coupon: {},
    };
  },
  async created() {
    this.getCouponDetail();
    this.initOpenWechatExe();
  },
  methods: {
    async initOpenWechatExe() {
      const c = new cloud.Cloud({
        // 必填，表示是未登录模式
        identityless: true,
        // 资源方 AppID
        resourceAppid: "小程序 AppID", // <!-- replace -->
        // 资源方环境 ID
        resourceEnv: "云开发环境 ID", // <!-- replace -->
      });

      await c.init();

      const res = await c.callFunction({
        name: "public",
        data: {
          action: "getUrlScheme",
        },
      });
      console.log(res.result.openlink);
    },
    toWechatExe() {
      const url = `weixin://dl/business/?appid=wxdde2780912209115&path=pages/index/index&env_version=release`;
      window.location.href = url;
    },
    async getCouponDetail() {
      const id = this.$route.query.id;
      const data = await api.getCouponDetail({ id });
      if (data.code === 200) {
        this.coupon = data.data;
      }
      console.log(data);
    },
    async reviceCoupon() {
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        this.$notify({ type: "warning", message: "手机号码格式不正确" });
      } else {
        this.$dialog
          .confirm({
            title: "提示",
            message: "确认领取优惠券吗?",
          })
          .then(async () => {
            try {
              this.$toast.loading({
                message: "领取中...",
                forbidClick: true,
              });
              const data = await api.reviceCoupon({ phone: this.phone });
              this.$toast.clear();
              if (data.code === 200) {
                this.$notify({ type: "success", message: "领取优惠券成功!" });
                this.phone = "";
              }
            } catch (e) {
              console.log(e);
              this.$toast.clear();
            }
          })
          .catch(() => {
            // on cancel
          });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.index-page {
  padding: 0.2rem;
  background-color: #e1e1e1;
  height: 100%;
  box-sizing: border-box;

  .logo-box {
    width: 100%;
    padding: 1rem 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.4rem;

    .logo {
      width: 2rem;
      height: 2rem;
    }
  }

  .button {
    width: 100%;
    height: 0.88rem;
    border-radius: 0.16rem;
    font-size: 0.32rem;
    color: #fff;
    background-color: #32aa38;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.4rem;
  }

  .form-item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.6rem;

    input {
      width: 100%;
      height: 0.8rem;
      font-size: 0.32rem;
      color: #000;
      text-align: center;
      padding: 0.12rem;
      border: 0.01rem solid #e1e1e1;
      border-radius: 0.12rem;

      &:focus {
        border-color: #32aa38;
      }
    }
  }

  .coupon-item {
    background: #ffffff;
    border-radius: 0.24rem;
    padding: 0.4rem;
    margin-bottom: 0.2rem;
    .coupon-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .left {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .price-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .symbol {
          font-weight: 500;
          font-size: 0.48rem;
          color: #32aa38;
        }

        .price {
          font-weight: 500;
          font-size: 0.6rem;
          color: #32aa38;
        }
      }

      .desc {
        color: #32aa38;
        font-size: 0.26rem;
        line-height: 0.48rem;
      }
    }

    .right {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 4.42rem;

      .right-left {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;

        .coupon-title {
          font-size: 0.32rem;
          font-weight: 500;
          line-height: 0.48rem;
          color: #333;
        }

        .desc {
          font-size: 0.26rem;
          color: #666;
          line-height: 0.48rem;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
      }
    }
  }
}
</style>